export function isPortrait({ height, width }) {
  return height >= width;
}

export default isPortrait;

export function isLandscape({ height, width }) {
  return !isPortrait({ height, width });
}
